import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {Segment} from 'main/stores/segmentation';

class EmployeeGroup extends DomainObject {
  name;
  readOnly;
  default;
  segment;

  _relations = {
    segment: Segment
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      readOnly: observable,
      default: observable,
      segment: observable
    });

    this.merge(other);
  }
}

export default EmployeeGroup;
